var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.66927 14.0002C11.1671 14.0002 14.0026 11.1646 14.0026 7.66683C14.0026 4.16903 11.1671 1.3335 7.66927 1.3335C4.17147 1.3335 1.33594 4.16903 1.33594 7.66683C1.33594 11.1646 4.17147 14.0002 7.66927 14.0002Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1978 14.6666C14.0778 14.6666 13.9578 14.62 13.8711 14.5333L12.6311 13.2933C12.4511 13.1133 12.4511 12.82 12.6311 12.6333C12.8111 12.4533 13.1044 12.4533 13.2911 12.6333L14.5311 13.8733C14.7111 14.0533 14.7111 14.3466 14.5311 14.5333C14.4378 14.62 14.3178 14.6666 14.1978 14.6666Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNormal);
export default __webpack_public_path__ + "static/media/search-normal.b4104e049d140e028ac845f9ed8d1a06.svg";
export { ForwardRef as ReactComponent };